import React from 'react'
import styled from 'styled-components'

import { ReactComponent as SuccessIcon } from '@/assets/svgs/green-house-checkmark-toggle.svg'

import { InformationSection } from '../../../components'
import { Button } from '../../../components/uikit'

const AnotherRequestButton = styled(Button)`
  margin-top: 24px;
  padding-top: 17px;
  padding-bottom: 17px;
`
export const SuccessfulHOR = ({
  onClickAnotherRequest,
}: {
  onClickAnotherRequest: () => void
}) => (
  <InformationSection
    title="Request Sent"
    iconProps={{ iconComponent: SuccessIcon, width: 175, height: 150 }}
  >
    <div>
      Our team will find the best options for you. We’ll email you as soon as
      they’re ready.
    </div>
    <AnotherRequestButton
      mode="primary"
      isFullWidth
      onClick={onClickAnotherRequest}
    >
      Send Another Request
    </AnotherRequestButton>
  </InformationSection>
)
